<script>import { cx } from "@emotion/css";
import { useTwistTheme, ResponsiveVars } from "..";
const twistTheme = useTwistTheme();
export let cols = $twistTheme.defaults.TwistGrid.cols;
export let colGaps = $twistTheme.defaults.TwistGrid.colGaps;
export let rowGaps = $twistTheme.defaults.TwistGrid.rowGaps;
$:
  className = new ResponsiveVars().addResponsive("grid-columns", cols).addFluid("grid-col-gap", colGaps).addFluid("grid-row-gap", rowGaps).toCSS();
</script>

<div class={cx('twist-grid', className)}>
  <slot />
</div>

<style>
  .twist-grid {
    display: grid;
    grid-template-columns: repeat(var(--grid-columns), minmax(0, 1fr));
    column-gap: var(--grid-col-gap);
    row-gap: var(--grid-row-gap);
  }
</style>
